/* ==========================================================================
   TestHelden v2 · assets/th-v2.js (Produktseite, Kollektion, Artikel) · Stand 15.10.2026
   Portiert aus testhelden-designsystem/system/js/v2.js (Kaufbereich, Galerie, Großansicht, Paketwahl, Vergleich,
   Zeitstrahl, App-Vorschau) plus die von v2 genutzten Teile aus core/commerce/content.js (Modal, Tabs, FAQ, Quiz,
   Inhaltsverzeichnis, Seitenleiste, Lesefortschritt, Video) – ohne Abhängigkeit vom Designsystem-Kern.
   Warenkorb: /cart/add mit Section Rendering, danach Event „cart:update“ und Philipps cart-drawer-component
   (wie sections/th-product-info.liquid; §356-Einwilligung im Drawer bleibt unberührt).
   Vanilla JS, idempotent (mehrfaches Laden durch mehrere Sections ist harmlos), Theme-Editor: shopify:section:load.
   ========================================================================== */
(function (window, document) {
  'use strict';
  if (window.thV2) { return; }

  var qs = function (sel, root) { return (root || document).querySelector(sel); };
  var qsa = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };
  var reduziert = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var desktop = window.matchMedia ? window.matchMedia('(min-width: 1024px)') : { matches: true };
  var FOKUSSIERBAR = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function einmal(el, key) {
    key = '__thV2' + key;
    if (el[key]) { return false; }
    el[key] = true;
    return true;
  }
  function msVon(el, name, standard) {
    var n = parseFloat(window.getComputedStyle(el).getPropertyValue(name));
    return isNaN(n) ? standard : n;
  }
  function escapeHtml(s) {
    return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; });
  }

  /* ---------- Modal (Großansicht): Fokusfalle, Esc, Scroll-Sperre, Fokus zurück ---------- */
  var offen = null;
  var modal = {
    oeffnen: function (el, oeffner) {
      if (!el) { return; }
      if (offen) { modal.schliessen(); }
      /* Fixed-Elemente nie in transformierten Section-Hüllen: Dialog in eine eigene .th-v2-Hülle an <body> hängen */
      if (!el.__thV2Body) {
        var huelle = document.createElement('div');
        huelle.className = 'th-v2 th-v2-portal';
        document.body.appendChild(huelle);
        huelle.appendChild(el);
        el.__thV2Body = true;
      }
      el.hidden = false;
      var dialog = qs('[role="dialog"]', el) || el;
      document.documentElement.style.overflow = 'hidden';
      function tab(ev) {
        if (ev.key === 'Escape') { ev.preventDefault(); modal.schliessen(); return; }
        if (ev.key !== 'Tab') { return; }
        var f = qsa(FOKUSSIERBAR, dialog).filter(function (x) { return x.offsetParent !== null; });
        if (!f.length) { return; }
        var erstes = f[0], letztes = f[f.length - 1];
        if (ev.shiftKey && document.activeElement === erstes) { ev.preventDefault(); letztes.focus(); }
        else if (!ev.shiftKey && document.activeElement === letztes) { ev.preventDefault(); erstes.focus(); }
      }
      el.addEventListener('keydown', tab);
      offen = { el: el, tab: tab, oeffner: oeffner || null };
      var start = qs('.th-modal__close', dialog) || dialog;
      window.requestAnimationFrame(function () { start.focus(); });
    },
    schliessen: function () {
      if (!offen) { return; }
      var m = offen;
      offen = null;
      m.el.hidden = true;
      m.el.removeEventListener('keydown', m.tab);
      document.documentElement.style.overflow = '';
      if (m.oeffner && m.oeffner.focus) { m.oeffner.focus(); }
    }
  };
  document.addEventListener('click', function (ev) {
    if (offen && ev.target.closest('[data-th-modal-close]') && offen.el.contains(ev.target)) { modal.schliessen(); }
  });

  /* ---------- Kaufbereich: klebende Spalte (pdp-framework-v2 2.5) ---------- */
  function initHero(root) {
    qsa('[data-th-v2-hero]', root).forEach(function (hero) {
      if (!einmal(hero, 'Hero')) { return; }
      var spalten = qsa('[data-th-v2-hero-col]', hero).filter(function (c) { return c.parentElement === hero; });
      if (spalten.length !== 2) { return; }
      var luft = 24, geplant = false;
      function messen() {
        geplant = false;
        spalten.forEach(function (c) { c.classList.remove('is-sticky'); c.style.removeProperty('--th-v2-sticky-top'); });
        if (!desktop.matches) { return; }
        var modus = hero.getAttribute('data-th-v2-hero') || 'auto';
        var ha = spalten[0].offsetHeight, hb = spalten[1].offsetHeight, kurz;
        if (modus === 'galerie') { kurz = spalten[0]; }
        else if (modus === 'kaufbox') { kurz = spalten[1]; }
        else {
          if (Math.abs(ha - hb) < luft) { return; }
          kurz = ha < hb ? spalten[0] : spalten[1];
        }
        var kopf = qs('header-component, .header, #header-group, .shopify-section-group-header-group');
        var oben = 0;
        if (kopf) {
          var stil = window.getComputedStyle(kopf);
          if (stil.position === 'sticky' || stil.position === 'fixed') { oben = Math.max(0, kopf.getBoundingClientRect().bottom); }
        }
        var h = kurz.offsetHeight;
        var top = (h + oben + 2 * luft <= window.innerHeight) ? oben + luft : window.innerHeight - h - luft;
        kurz.style.setProperty('--th-v2-sticky-top', Math.round(top) + 'px');
        kurz.classList.add('is-sticky');
      }
      function planen() { if (!geplant) { geplant = true; window.requestAnimationFrame(messen); } }
      planen();
      window.addEventListener('resize', planen);
      if (desktop.addEventListener) { desktop.addEventListener('change', planen); }
      if ('ResizeObserver' in window) {
        var ro = new window.ResizeObserver(planen);
        spalten.forEach(function (c) { ro.observe(c); });
      }
      qsa('img', hero).forEach(function (img) { if (!img.complete) { img.addEventListener('load', planen, { once: true }); } });
    });
  }

  /* ---------- Galerie: Punkte und Wischen unter 1024 px ---------- */
  function initGalerie(root) {
    qsa('[data-th-v2-gallery]', root).forEach(function (gal) {
      if (!einmal(gal, 'Gal')) { return; }
      var liste = qs('[data-th-v2-gallery-list]', gal), dots = qs('[data-th-v2-gallery-dots]', gal);
      if (!liste || !dots) { return; }
      var items = qsa('[data-th-v2-item]', liste);
      dots.innerHTML = '';
      if (items.length < 2) { return; }
      var knoepfe = items.map(function (item, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'th-v2-gallery__dot';
        b.setAttribute('aria-label', 'Bild ' + (i + 1) + ' von ' + items.length + ': ' + (item.getAttribute('data-th-v2-caption') || ''));
        b.addEventListener('click', function () {
          liste.scrollTo({ left: item.offsetLeft - liste.offsetLeft, behavior: reduziert ? 'auto' : 'smooth' });
        });
        dots.appendChild(b);
        return b;
      });
      function aktuell() {
        var breite = items[0].getBoundingClientRect().width || 1;
        var lueck = parseFloat(window.getComputedStyle(liste).columnGap) || 0;
        var i = Math.max(0, Math.min(items.length - 1, Math.round(liste.scrollLeft / (breite + lueck))));
        knoepfe.forEach(function (k, j) { k.setAttribute('aria-current', j === i ? 'true' : 'false'); });
      }
      var tick = false;
      liste.addEventListener('scroll', function () {
        if (tick) { return; }
        tick = true;
        window.requestAnimationFrame(function () { tick = false; aktuell(); });
      }, { passive: true });
      aktuell();
    });
  }

  /* ---------- Großansicht (Galerie und App-Vorschau) ---------- */
  var gross = { modal: null, gruppe: null, items: [], index: 0 };
  function zeige(index) {
    var m = gross.modal, n = gross.items.length;
    if (!m || !n) { return; }
    gross.index = (index + n) % n;
    var item = gross.items[gross.index];
    var inhalt = qs('[data-th-v2-inhalt]', item), buehne = qs('[data-th-v2-lightbox-buehne]', m);
    if (!buehne || !inhalt) { return; }
    var klon = inhalt.cloneNode(true);
    klon.removeAttribute('id');
    qsa('[id]', klon).forEach(function (el) { el.removeAttribute('id'); });
    qsa('[data-th-v2-open]', klon).forEach(function (b) { b.parentNode.removeChild(b); });
    qsa('img', klon).forEach(function (img) {
      var g = img.getAttribute('data-th-v2-gross');
      if (g) { img.removeAttribute('srcset'); img.removeAttribute('sizes'); img.src = g; }
      img.loading = 'eager';
    });
    buehne.innerHTML = '';
    buehne.appendChild(klon);
    var caption = qs('[data-th-v2-lightbox-caption]', m);
    if (caption) { caption.textContent = item.getAttribute('data-th-v2-caption') || ''; }
    var zaehler = qs('[data-th-v2-lightbox-zaehler]', m);
    var wort = gross.gruppe.getAttribute('data-th-v2-zaehlwort') || 'Bild';
    if (zaehler) { zaehler.textContent = wort + ' ' + (gross.index + 1) + ' von ' + n; }
    qsa('[data-th-v2-lightbox-prev], [data-th-v2-lightbox-next]', m).forEach(function (b) { b.hidden = n < 2; });
  }
  function oeffneGross(gruppe, index, oeffner) {
    var m = document.querySelector(gruppe.getAttribute('data-th-v2-lightbox'));
    if (!m) { return; }
    gross.modal = m;
    gross.gruppe = gruppe;
    gross.items = qsa('[data-th-v2-item]', gruppe);
    var titel = qs('[data-th-v2-lightbox-titel]', m);
    if (titel) { titel.textContent = gruppe.getAttribute('data-th-v2-lightbox-titel') || 'Großansicht'; }
    var ansicht = (gruppe.getAttribute('data-th-v2-zaehlwort') || 'Bild') === 'Ansicht';
    var prev = qs('[data-th-v2-lightbox-prev]', m), next = qs('[data-th-v2-lightbox-next]', m);
    if (prev) { prev.setAttribute('aria-label', ansicht ? 'Vorherige Ansicht' : 'Vorheriges Bild'); }
    if (next) { next.setAttribute('aria-label', ansicht ? 'Nächste Ansicht' : 'Nächstes Bild'); }
    if (einmal(m, 'Lb')) {
      if (prev) { prev.addEventListener('click', function () { zeige(gross.index - 1); }); }
      if (next) { next.addEventListener('click', function () { zeige(gross.index + 1); }); }
      m.addEventListener('keydown', function (ev) {
        if (ev.key === 'ArrowLeft') { ev.preventDefault(); zeige(gross.index - 1); }
        if (ev.key === 'ArrowRight') { ev.preventDefault(); zeige(gross.index + 1); }
      });
    }
    zeige(index);
    modal.oeffnen(m, oeffner);
  }
  function initGrossansicht(root) {
    qsa('[data-th-v2-open]', root).forEach(function (btn) {
      if (!einmal(btn, 'Open')) { return; }
      btn.addEventListener('click', function () {
        var gruppe = btn.closest('[data-th-v2-lightbox]'), item = btn.closest('[data-th-v2-item]');
        if (!gruppe || !item) { return; }
        oeffneGross(gruppe, qsa('[data-th-v2-item]', gruppe).indexOf(item), btn);
      });
    });
  }

  /* ---------- Paketwahl (K2) + Preis, Sticky-Leiste, Variante in der URL ---------- */
  function kaufbox(el) { return el.closest('[data-th-buy]'); }
  /* Alte Woo-Paketlinks (Suchanzeigen): /produkt/<slug>/?attribute_pa_paket=komplettpaket-xl kommt per 301
     als /products/<slug>?attribute_pa_paket=komplettpaket-xl an. Der Wert ist der Handle des Paketnamens
     (geprüft für alle 1.900 Woo-Varianten, 17.10.2026). Passendes Paket vorwählen, URL auf ?variant= (MCA-12). */
  function paketHandle(s) {
    return String(s || '').toLowerCase().replace(/ä/g, 'ae').replace(/ö/g, 'oe').replace(/ü/g, 'ue').replace(/ß/g, 'ss')
      .replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }
  function paketAusAltlink(inputs) {
    try {
      var url = new URL(window.location.href);
      var alt = url.searchParams.get('attribute_pa_paket');
      if (!alt || url.searchParams.get('variant')) { return null; }
      var ziel = paketHandle(alt);
      return inputs.filter(function (i) { return !i.disabled && paketHandle(i.getAttribute('data-name')) === ziel; })[0] || null;
    } catch (e) { return null; }
  }
  function altlinkUrl(variantId) {
    if (!window.history || !window.history.replaceState) { return; }
    try {
      var url = new URL(window.location.href);
      url.searchParams.delete('attribute_pa_paket');
      url.searchParams.set('variant', variantId);
      window.history.replaceState({}, '', url.toString());
    } catch (e) { /* ohne URL-API: nichts */ }
  }
  function initPaketwahl(root) {
    qsa('[data-th-v2-pkg]', root).forEach(function (fs) {
      if (!einmal(fs, 'Pkg')) { return; }
      var box = kaufbox(fs);
      var inputs = qsa('[data-th-pkg-input]', fs);
      function anwenden(input, animiert) {
        qsa('.th-v2-pkg__card', fs).forEach(function (karte) {
          var an = qs('[data-th-pkg-input]', karte) === input;
          karte.classList.toggle('is-selected', an);
          var detail = qs('[data-th-v2-pkg-detail]', karte);
          if (!detail) { return; }
          if (!an) { detail.hidden = true; return; }
          if (!detail.hidden) { return; }
          detail.hidden = false;
          var dauer = msVon(fs, '--th-v2-pkg-dauer', 200);
          if (animiert && dauer > 0 && !reduziert && detail.animate) {
            detail.animate([{ height: '0px', opacity: 0 }, { height: detail.offsetHeight + 'px', opacity: 1 }], { duration: dauer, easing: 'cubic-bezier(0.4, 0, 0.2, 1)' });
          }
        });
        var name = input.getAttribute('data-name') || input.value;
        var preis = input.getAttribute('data-preis') || '';
        if (box) {
          qsa('[data-th-buy-price]', box).forEach(function (el) { el.textContent = preis; });
          qsa('[data-th-buy-pkg]', box).forEach(function (el) { el.textContent = name + ', '; });
        }
        qsa('[data-th-sticky-pkg]').forEach(function (el) { el.textContent = name; });
        qsa('[data-th-sticky-value]').forEach(function (el) { el.textContent = preis; });
        if (animiert && window.history && window.history.replaceState) {
          try {
            var url = new URL(window.location.href);
            url.searchParams.set('variant', input.value);
            window.history.replaceState({}, '', url.toString());
          } catch (e) { /* ohne URL-API: nichts */ }
        }
        document.dispatchEvent(new CustomEvent('th:v2-paket', { detail: { fieldset: fs, name: name, id: input.value } }));
      }
      inputs.forEach(function (input) {
        input.addEventListener('change', function () { if (input.checked) { anwenden(input, true); } });
      });
      var altlink = paketAusAltlink(inputs);
      if (altlink) { inputs.forEach(function (i) { i.checked = i === altlink; }); }
      var aktiv = inputs.filter(function (i) { return i.checked; })[0] || inputs.filter(function (i) { return !i.disabled; })[0];
      if (aktiv) { aktiv.checked = true; anwenden(aktiv, false); }
      if (altlink) { altlinkUrl(altlink.value); }
    });
    /* „Dieses Paket wählen“ (Vergleich): Paket in der Kaufbox wählen und dorthin springen */
    qsa('[data-th-pkg-select]', root).forEach(function (btn) {
      if (!einmal(btn, 'PkgSel')) { return; }
      btn.addEventListener('click', function () {
        var id = btn.getAttribute('data-th-pkg-select');
        var input = qs('[data-th-pkg-input][value="' + id + '"]');
        if (!input || input.disabled) { return; }
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
        var box = kaufbox(input) || input;
        box.scrollIntoView({ block: 'start', behavior: reduziert ? 'auto' : 'smooth' });
        window.setTimeout(function () { input.focus({ preventScroll: true }); }, reduziert ? 0 : 400);
      });
    });
  }

  /* ---------- Vergleichstabelle folgt der Paketwahl (K3) ---------- */
  function vergleichMarkieren(v, name) {
    qsa('[data-th-v2-spalte]', v).forEach(function (z) { z.classList.toggle('is-highlight', z.getAttribute('data-th-v2-spalte') === name); });
    qsa('[data-th-v2-paket]', v).forEach(function (det) {
      var an = det.getAttribute('data-th-v2-paket') === name;
      det.classList.toggle('is-highlight', an);
      if (an) { det.open = true; }
    });
  }
  function initVergleich(root) {
    qsa('[data-th-v2-vergleich]', root).forEach(function (v) {
      if (!einmal(v, 'Vgl')) { return; }
      var r = qs('[data-th-v2-pkg] [data-th-pkg-input]:checked');
      if (r) { vergleichMarkieren(v, r.getAttribute('data-name')); }
      document.addEventListener('th:v2-paket', function (ev) { vergleichMarkieren(v, ev.detail.name); });
    });
  }

  /* ---------- Warenkorb: Formular per fetch, Drawer von Philipp öffnen ---------- */
  function drawerOeffnen(form, data, btn) {
    var variant = qs('input[name="id"]:checked, input[name="id"][type="hidden"]', form);
    document.dispatchEvent(new CustomEvent('cart:update', {
      bubbles: true,
      detail: {
        resource: data,
        sourceId: form.getAttribute('data-th-v2-form') || 'th-v2',
        data: { source: 'th-v2', productId: (kaufbox(form) || form).getAttribute('data-product-handle'), variantId: variant ? variant.value : undefined, sections: data.sections }
      }
    }));
    if (!document.querySelector('cart-drawer-component')) { window.location.href = '/cart'; return; }
    var oeffne = function () {
      var drawer = document.querySelector('cart-drawer-component');
      if (drawer && typeof drawer.open === 'function') { drawer.returnFocusTo = btn; drawer.open(); }
      else { window.location.href = '/cart'; }
    };
    if (window.customElements && window.customElements.get('cart-drawer-component')) { oeffne(); }
    else if (window.customElements) { window.customElements.whenDefined('cart-drawer-component').then(oeffne); }
    else { window.location.href = '/cart'; }
  }
  function initForm(root) {
    qsa('form[data-th-v2-form]', root).forEach(function (form) {
      if (!einmal(form, 'Form')) { return; }
      form.addEventListener('submit', function (ev) {
        ev.preventDefault();
        var btn = qs('[type="submit"]', form);
        if (btn && btn.disabled) { return; }
        if (btn) { btn.setAttribute('aria-busy', 'true'); btn.disabled = true; }
        var fd = new FormData(form);
        var ids = [];
        qsa('cart-items-component[data-section-id]').forEach(function (el) {
          var id = el.getAttribute('data-section-id');
          if (id && ids.indexOf(id) === -1) { ids.push(id); }
        });
        if (ids.length) { fd.append('sections', ids.join(',')); }
        fetch(form.action, { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' }, body: fd })
          .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
          .then(function (r) {
            if (!r.ok || r.data.status) { throw new Error(r.data.description || r.data.message || 'Warenkorb-Fehler'); }
            drawerOeffnen(form, r.data, btn);
          })
          .catch(function (err) {
            if (window.console) { window.console.error('[th-v2] Warenkorb:', err); }
            form.submit();
          })
          .then(function () { if (btn) { btn.setAttribute('aria-busy', 'false'); btn.disabled = false; } });
      });
    });
    /* Weitere Kaufknöpfe (Sticky-Leiste, Final-CTA) lösen das Hauptformular aus */
    qsa('[data-th-buy-add]', root).forEach(function (btn) {
      if (!einmal(btn, 'BuyAdd')) { return; }
      btn.addEventListener('click', function () {
        var form = qs('form[data-th-v2-form]');
        if (!form) { return; }
        if (form.requestSubmit) { form.requestSubmit(); } else { form.dispatchEvent(new Event('submit', { cancelable: true })); }
      });
    });
  }

  /* ---------- Sticky-Kaufleiste: erscheint, wenn der Primär-CTA oben aus dem Bild ist (§1) ----------
     Mobil (bis 767 px, 04.11.2026, Befund 34a B5): auch, solange der CTA noch UNTER dem Bild liegt. Der Kaufknopf lag
     mobil 1.400 bis 2.100 px tief, Preis und Knopf fehlten im ersten Bildschirm. Die Leiste zeigt ab dem ersten
     Bildschirm Paketname + Preis der gewählten Stufe + Kaufknopf und verschwindet, sobald der echte CTA im Bild ist.
     Desktop bleibt wie bisher (Leiste erst, wenn der CTA oben hinaus ist). */
  var mobilMq = window.matchMedia ? window.matchMedia('(max-width: 767px)') : null;
  function initSticky(root) {
    qsa('[data-th-sticky]', root).forEach(function (leiste) {
      if (!einmal(leiste, 'Sticky')) { return; }
      var ziel = document.querySelector(leiste.getAttribute('data-th-sticky-target'));
      if (!ziel) { return; }
      var verbergen = false;
      var knopf = qs('[data-th-buy-add]', leiste);
      function update() {
        var r = ziel.getBoundingClientRect();
        var weg = r.bottom < 0 || (!!(mobilMq && mobilMq.matches) && r.height > 0 && r.top > window.innerHeight);
        var an = weg && !verbergen;
        leiste.classList.toggle('is-visible', an);
        leiste.setAttribute('aria-hidden', an ? 'false' : 'true');
        if (knopf) { knopf.tabIndex = an ? 0 : -1; }
        if ('inert' in leiste) { leiste.inert = !an; }
      }
      var tick = false;
      function plan() { if (!tick) { tick = true; window.requestAnimationFrame(function () { tick = false; update(); }); } }
      window.addEventListener('scroll', plan, { passive: true });
      window.addEventListener('resize', plan, { passive: true });
      if ('IntersectionObserver' in window) {
        var io = new window.IntersectionObserver(function (e) {
          verbergen = e.some(function (x) { return x.isIntersecting; });
          update();
        }, { threshold: 0 });
        qsa('[data-th-sticky-hide]').forEach(function (el) { io.observe(el); });
      }
      update();
    });
  }

  /* ---------- Zeitstrahl (K4) ---------- */
  function initZeit(root) {
    qsa('[data-th-v2-zeit]', root).forEach(function (z) {
      if (!einmal(z, 'Zeit')) { return; }
      qsa('.th-v2-zeit__station', z).forEach(function (s, i) { s.style.setProperty('--th-v2-i', String(i)); });
      if (reduziert || !('IntersectionObserver' in window)) { return; }
      z.classList.add('is-armed');
      var io = new window.IntersectionObserver(function (e) {
        e.forEach(function (x) {
          if (!x.isIntersecting) { return; }
          io.disconnect();
          window.requestAnimationFrame(function () { window.requestAnimationFrame(function () { z.classList.add('is-run'); }); });
        });
      }, { threshold: 0.4 });
      io.observe(z);
    });
  }

  /* ---------- App-Vorschau (K11) ---------- */
  function initApp(root) {
    qsa('[data-th-v2-app]', root).forEach(function (app) {
      if (!einmal(app, 'App')) { return; }
      var liste = qs('[data-th-v2-app-liste]', app);
      var prev = qs('[data-th-v2-app-prev]', app), next = qs('[data-th-v2-app-next]', app);
      if (!liste) { return; }
      function schritt() {
        var item = qs('.th-v2-app__item', liste);
        var lueck = parseFloat(window.getComputedStyle(liste).columnGap) || 0;
        return item ? item.getBoundingClientRect().width + lueck : liste.clientWidth;
      }
      function zustand() {
        var max = liste.scrollWidth - liste.clientWidth - 2;
        if (prev) { prev.disabled = liste.scrollLeft <= 2; }
        if (next) { next.disabled = liste.scrollLeft >= max; }
      }
      if (prev) { prev.addEventListener('click', function () { liste.scrollBy({ left: -schritt(), behavior: reduziert ? 'auto' : 'smooth' }); }); }
      if (next) { next.addEventListener('click', function () { liste.scrollBy({ left: schritt(), behavior: reduziert ? 'auto' : 'smooth' }); }); }
      var tick = false;
      liste.addEventListener('scroll', function () {
        if (tick) { return; }
        tick = true;
        window.requestAnimationFrame(function () { tick = false; zustand(); });
      }, { passive: true });
      window.addEventListener('resize', zustand);
      zustand();
    });
  }

  /* ---------- Kursinhalt „weitere Bereiche“, verwandte Trainer „alle anzeigen“ ---------- */
  function initMehr(root) {
    qsa('[data-th-contents-more]', root).forEach(function (btn) {
      if (!einmal(btn, 'Mehr')) { return; }
      var box = btn.closest('[data-th-contents]');
      var text = btn.textContent;
      btn.addEventListener('click', function () {
        var auf = btn.getAttribute('aria-expanded') !== 'true';
        qsa('[data-th-contents-rest]', box).forEach(function (li) { li.hidden = !auf; });
        btn.setAttribute('aria-expanded', auf ? 'true' : 'false');
        btn.textContent = auf ? 'Weniger anzeigen' : text;
      });
    });
    qsa('[data-th-related-mehr]', root).forEach(function (btn) {
      if (!einmal(btn, 'RelMehr')) { return; }
      btn.addEventListener('click', function () {
        var box = btn.closest('[data-th-related]') || btn.parentElement;
        var erstes = null;
        qsa('[data-th-related-rest]', box).forEach(function (li) { li.hidden = false; if (!erstes) { erstes = qs('a', li); } });
        btn.parentNode.removeChild(btn);
        if (erstes) { erstes.focus(); }
      });
    });
  }

  /* ---------- Tabs (verwandte Trainer) ---------- */
  function initTabs(root) {
    qsa('[data-th-tabs]', root).forEach(function (tabs) {
      if (!einmal(tabs, 'Tabs')) { return; }
      var liste = qsa('[role="tab"]', tabs);
      if (!liste.length) { return; }
      function waehle(tab, fokus) {
        liste.forEach(function (t) {
          var an = t === tab;
          t.setAttribute('aria-selected', an ? 'true' : 'false');
          t.tabIndex = an ? 0 : -1;
          var p = document.getElementById(t.getAttribute('aria-controls'));
          if (p) { p.hidden = !an; }
        });
        if (fokus) { tab.focus(); }
      }
      liste.forEach(function (t, i) {
        t.addEventListener('click', function () { waehle(t, false); });
        t.addEventListener('keydown', function (ev) {
          var n = null;
          if (ev.key === 'ArrowRight') { n = liste[(i + 1) % liste.length]; }
          if (ev.key === 'ArrowLeft') { n = liste[(i - 1 + liste.length) % liste.length]; }
          if (ev.key === 'Home') { n = liste[0]; }
          if (ev.key === 'End') { n = liste[liste.length - 1]; }
          if (n) { ev.preventDefault(); waehle(n, true); }
        });
      });
    });
  }

  /* ---------- FAQ: eine Frage offen ---------- */
  function initFaq(root) {
    qsa('[data-th-faq-single]', root).forEach(function (faq) {
      if (!einmal(faq, 'Faq')) { return; }
      faq.addEventListener('toggle', function (ev) {
        var d = ev.target;
        if (d.tagName !== 'DETAILS' || !d.open) { return; }
        qsa('details', faq).forEach(function (a) { if (a !== d && a.open) { a.open = false; } });
      }, true);
    });
  }

  /* ---------- Quiz: Beispielfragen („Lösung anzeigen“) und interaktiv (E14) ---------- */
  function markSr(o, text) {
    qsa('.th-quiz__sr', o).forEach(function (sr) { sr.parentNode.removeChild(sr); });
    if (!text) { return; }
    var span = document.createElement('span');
    span.className = 'th-sr-only th-quiz__sr';
    span.textContent = ' (' + text + ')';
    (qs('.th-quiz__label', o) || o).appendChild(span);
  }
  function initBeispiele(root) {
    qsa('[data-th-quiz-loesung]', root).forEach(function (btn) {
      if (!einmal(btn, 'Loesung')) { return; }
      var karte = btn.closest('[data-th-quiz-beispiel]');
      if (!karte) { return; }
      var richtig = parseInt(karte.getAttribute('data-th-quiz-richtig') || '-1', 10);
      var optionen = qsa('.th-quiz__option', karte);
      var explain = qs('[data-th-quiz-explain]', karte);
      var zeigen = btn.textContent.trim();
      btn.addEventListener('click', function () {
        var auf = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', auf ? 'false' : 'true');
        optionen.forEach(function (o, n) {
          var an = !auf && n === richtig;
          o.classList.toggle('is-correct', an);
          markSr(o, an ? 'richtige Antwort' : '');
        });
        if (explain) { explain.hidden = auf; }
        btn.textContent = auf ? zeigen : 'Lösung verbergen';
      });
    });
  }
  function quizNorm(t) {
    return String(t || '').toLowerCase().replace(/\s+/g, ' ').replace(/[.!?,;:"„“»«()]/g, '').trim();
  }
  function quizPush(ev) {
    try { (window.dataLayer = window.dataLayer || []).push(ev); } catch (e) {}
  }
  function initQuiz(root) {
    qsa('[data-th-quiz]', root).forEach(function (quiz) {
      if (!einmal(quiz, 'Quiz')) { return; }
      var screens = { start: qs('[data-th-quiz-screen="start"]', quiz), fragen: qs('[data-th-quiz-screen="fragen"]', quiz), ergebnis: qs('[data-th-quiz-screen="ergebnis"]', quiz) };
      var fragen = qsa('[data-th-quiz-frage]', quiz);
      if (!fragen.length || !screens.fragen) { return; }
      var countEl = qs('[data-th-quiz-count]', quiz), barEl = qs('[data-th-quiz-bar]', quiz), progressEl = qs('[role="progressbar"]', quiz);
      var pruefen = qs('[data-th-quiz-pruefen]', quiz), weiter = qs('[data-th-quiz-weiter]', quiz), hinweis = qs('[data-th-quiz-hinweis]', quiz);
      var formId = quiz.getAttribute('data-th-quiz-form-id') || '';
      var index = 0, antworten = [], gestartet = false;
      function art(f) { return f.getAttribute('data-th-quiz-art') || 'einfach'; }
      function richtigListe(f) {
        return (f.getAttribute('data-th-quiz-richtig') || '').split(',').filter(function (x) { return x !== ''; }).map(function (x) { return parseInt(x, 10); });
      }
      function zeigeScreen(name) { Object.keys(screens).forEach(function (k) { if (screens[k]) { screens[k].hidden = k !== name; } }); }
      function fortschritt(erledigt) {
        var pct = Math.round((erledigt / fragen.length) * 100);
        if (barEl) { barEl.style.setProperty('--th-progress', pct + '%'); }
        if (progressEl) { progressEl.setAttribute('aria-valuenow', String(erledigt)); progressEl.setAttribute('aria-valuetext', erledigt + ' von ' + fragen.length + ' beantwortet'); }
      }
      function setzePruefen(an) { if (pruefen) { pruefen.setAttribute('aria-disabled', an ? 'false' : 'true'); } if (hinweis) { hinweis.textContent = ''; } }
      function zeigeFrage(i) {
        index = i;
        fragen.forEach(function (f, n) { f.hidden = n !== i; });
        var f = fragen[i];
        f.classList.remove('is-aufgeloest');
        qsa('.th-quiz__option', f).forEach(function (o) { o.classList.remove('is-selected', 'is-correct', 'is-wrong'); markSr(o, ''); });
        qsa('input', f).forEach(function (inp) { inp.checked = false; inp.disabled = false; if (inp.type === 'text') { inp.value = ''; inp.removeAttribute('aria-invalid'); } });
        var feld = qs('.th-quiz__frei', f);
        if (feld) { feld.classList.remove('is-correct', 'is-wrong'); }
        var ex = qs('[data-th-quiz-explain]', f);
        if (ex) { ex.hidden = true; }
        if (countEl) { countEl.textContent = (i + 1) + ' / ' + fragen.length; }
        fortschritt(i);
        if (pruefen) { pruefen.hidden = false; }
        if (weiter) { weiter.hidden = true; }
        setzePruefen(false);
        var oben = screens.fragen.getBoundingClientRect().top;
        if (oben < 0 || oben > window.innerHeight) { screens.fragen.scrollIntoView({ block: 'start', behavior: reduziert ? 'auto' : 'smooth' }); }
        var erstes = qs('input', f);
        if (erstes) { erstes.focus({ preventScroll: true }); }
      }
      function aufloesen() {
        var f = fragen[index];
        if (f.classList.contains('is-aufgeloest')) { return; }
        var typ = art(f), richtig = richtigListe(f), korrekt = false;
        if (typ === 'frei') {
          var inp = qs('[data-th-quiz-frei-input]', f);
          if (!inp || !inp.value.trim()) { if (hinweis) { hinweis.textContent = 'Bitte gib zuerst eine Antwort ein.'; } return; }
          korrekt = quizNorm(inp.value) === quizNorm(f.getAttribute('data-th-quiz-loesung'));
          inp.disabled = true;
          var feld = qs('.th-quiz__frei', f);
          if (feld) { feld.classList.add(korrekt ? 'is-correct' : 'is-wrong'); }
        } else {
          var optionen = qsa('.th-quiz__option', f);
          var gewaehlt = [];
          optionen.forEach(function (o, n) { var i = qs('input', o); if (i && i.checked) { gewaehlt.push(n); } });
          if (!gewaehlt.length) { if (hinweis) { hinweis.textContent = 'Bitte wähle zuerst eine Antwort.'; } return; }
          korrekt = gewaehlt.length === richtig.length && gewaehlt.every(function (n) { return richtig.indexOf(n) >= 0; });
          optionen.forEach(function (o, n) {
            o.classList.remove('is-selected');
            var istRichtig = richtig.indexOf(n) >= 0, istGewaehlt = gewaehlt.indexOf(n) >= 0;
            if (istRichtig) { o.classList.add('is-correct'); markSr(o, istGewaehlt ? 'richtige Antwort, deine Wahl' : 'richtige Antwort'); }
            else if (istGewaehlt) { o.classList.add('is-wrong'); markSr(o, 'deine Antwort, falsch'); }
          });
          qsa('input', f).forEach(function (inp) { inp.disabled = true; });
        }
        f.classList.add('is-aufgeloest');
        antworten[index] = korrekt;
        var ex = qs('[data-th-quiz-explain]', f);
        if (ex) {
          ex.classList.remove('th-quiz__explain--richtig', 'th-quiz__explain--falsch');
          ex.classList.add(korrekt ? 'th-quiz__explain--richtig' : 'th-quiz__explain--falsch');
          var t = qs('[data-th-quiz-explain-title]', ex);
          if (t) { t.innerHTML = '<span>' + (korrekt ? 'Richtig' : 'Leider falsch') + '</span>'; }
          ex.hidden = false;
          ex.setAttribute('tabindex', '-1');
          ex.focus({ preventScroll: false });
        }
        fortschritt(index + 1);
        if (pruefen) { pruefen.hidden = true; }
        if (weiter) { weiter.hidden = false; weiter.textContent = index + 1 < fragen.length ? 'Weiter' : 'Ergebnis ansehen'; }
      }
      function bereiche() {
        var box = qs('[data-th-quiz-bars]', quiz);
        if (!box) { return; }
        var werte = {}, reihenfolge = [];
        fragen.forEach(function (f, n) {
          var b = f.getAttribute('data-th-quiz-bereich');
          if (!b) { return; }
          if (!werte[b]) { werte[b] = { ok: 0, n: 0 }; reihenfolge.push(b); }
          werte[b].n++;
          if (antworten[n]) { werte[b].ok++; }
        });
        box.textContent = '';
        if (reihenfolge.length < 2) { box.hidden = true; return; }
        reihenfolge.sort(function (a, b) { return werte[a].ok / werte[a].n - werte[b].ok / werte[b].n; });
        // Höchstens 6 Zeilen, schwächste Bereiche zuerst: dort lohnt sich Üben
        reihenfolge.slice(0, 6).forEach(function (b, i) {
          var w = werte[b], zeile = document.createElement('div');
          zeile.className = 'th-quiz__bar';
          var label = document.createElement('span');
          label.className = 'th-quiz__bar-label';
          label.textContent = b;
          if (i === 0 && w.ok < w.n) {
            var h = document.createElement('span');
            h.className = 'th-quiz__bar-hinweis';
            h.textContent = 'hier lohnt sich Üben am meisten';
            label.appendChild(h);
          }
          var wert = document.createElement('span');
          wert.className = 'th-quiz__bar-value';
          wert.textContent = w.ok + ' von ' + w.n;
          var spur = document.createElement('div');
          spur.className = 'th-quiz__bar-track';
          spur.setAttribute('aria-hidden', 'true');
          var fill = document.createElement('div');
          fill.className = 'th-quiz__bar-fill';
          fill.style.setProperty('--th-progress', Math.round((w.ok / w.n) * 100) + '%');
          spur.appendChild(fill);
          zeile.appendChild(label); zeile.appendChild(wert); zeile.appendChild(spur);
          box.appendChild(zeile);
        });
        box.hidden = false;
      }
      function ergebnis() {
        var n = antworten.filter(Boolean).length;
        var s = qs('[data-th-quiz-score]', quiz), t = qs('[data-th-quiz-score-text]', quiz);
        if (s) { s.textContent = n + ' von ' + fragen.length; }
        if (t) {
          var q = n / fragen.length;
          t.textContent = q >= 0.8 ? 'Starke Grundlage. Im Trainer übst du alle Aufgabentypen und simulierst die Prüfung.'
            : (q >= 0.5 ? 'Guter Start. Gezieltes Üben bringt dich jetzt am weitesten.' : 'Noch Luft nach oben. Genau dafür ist der Trainer da: Schritt für Schritt üben, bis die Aufgabentypen sitzen.');
        }
        bereiche();
        zeigeScreen('ergebnis');
        quizPush({ event: 'th_quiz_complete', quiz_id: formId, quiz_score: n, quiz_total: fragen.length });
        if (s) { s.setAttribute('tabindex', '-1'); s.focus({ preventScroll: false }); }
      }
      function start() {
        antworten = [];
        zeigeScreen('fragen');
        zeigeFrage(0);
        if (!gestartet) { gestartet = true; quizPush({ event: 'th_quiz_start', quiz_id: formId }); }
      }
      quiz.addEventListener('change', function (ev) {
        var inp = ev.target;
        if (inp.type !== 'radio' && inp.type !== 'checkbox') { return; }
        var f = inp.closest('[data-th-quiz-frage]');
        if (!f || f.classList.contains('is-aufgeloest')) { return; }
        if (inp.type === 'radio') { qsa('.th-quiz__option', f).forEach(function (o) { o.classList.remove('is-selected'); }); }
        var o = inp.closest('.th-quiz__option');
        if (o) { o.classList.toggle('is-selected', inp.checked); }
        setzePruefen(qsa('input:checked', f).length > 0);
      });
      quiz.addEventListener('input', function (ev) {
        var inp = ev.target;
        if (!inp.hasAttribute || !inp.hasAttribute('data-th-quiz-frei-input')) { return; }
        setzePruefen(inp.value.trim() !== '');
      });
      quiz.addEventListener('keydown', function (ev) {
        if (ev.key === 'Enter' && ev.target.hasAttribute && ev.target.hasAttribute('data-th-quiz-frei-input')) { ev.preventDefault(); aufloesen(); }
      });
      quiz.addEventListener('click', function (ev) {
        if (ev.target.closest('[data-th-quiz-start]')) { start(); }
        else if (ev.target.closest('[data-th-quiz-pruefen]')) { aufloesen(); }
        else if (ev.target.closest('[data-th-quiz-weiter]')) { if (index + 1 < fragen.length) { zeigeFrage(index + 1); } else { ergebnis(); } }
        else if (ev.target.closest('[data-th-quiz-neustart]')) { start(); }
      });
      var formular = screens.fragen;
      if (formular && formular.tagName === 'FORM') { formular.addEventListener('submit', function (ev) { ev.preventDefault(); }); }

      // Ergebnis + Fragensammlung als PDF (Plattform /api/mobile/quiz-lead: Fragen kommen dort
      // aus dem th_quiz-Metaobjekt, Kontakt geht über das hinterlegte ActiveCampaign-Formular).
      var lead = qs('[data-th-quiz-lead-form]', quiz);
      if (lead && formId) {
        lead.addEventListener('submit', function (ev) {
          ev.preventDefault();
          var mail = qs('[data-th-quiz-lead-email]', lead), fehler = qs('[data-th-quiz-lead-fehler]', lead);
          var status = qs('[data-th-quiz-lead-status]', quiz), knopf = qs('button[type="submit"]', lead);
          var wert = (mail.value || '').trim();
          if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(wert)) {
            mail.setAttribute('aria-invalid', 'true');
            if (fehler) { fehler.hidden = false; }
            mail.focus();
            return;
          }
          mail.removeAttribute('aria-invalid');
          if (fehler) { fehler.hidden = true; }
          knopf.disabled = true;
          status.hidden = false;
          status.textContent = 'Einen Moment, dein PDF wird erstellt …';
          var termin = qs('input[name="examDate"]', lead);
          fetch('https://app.testhelden.com/api/mobile/quiz-lead', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              email: wert,
              formId: formId,
              score: antworten.filter(Boolean).length,
              total: fragen.length,
              sourceUrl: location.href.split('?')[0].split('#')[0],
              examDate: (termin && termin.value) || undefined
            })
          }).then(function (res) {
            if (!res.ok) { throw new Error('http-' + res.status); }
            lead.hidden = true;
            status.textContent = 'Geschafft! Deine Fragensammlung ist unterwegs in dein Postfach.';
            status.focus({ preventScroll: true });
            quizPush({ event: 'th_quiz_lead', quiz_id: formId });
          }).catch(function () {
            knopf.disabled = false;
            status.textContent = 'Das hat leider nicht geklappt. Bitte versuche es gleich noch einmal.';
          });
        });
      }
      if (screens.start) { zeigeScreen('start'); }
    });
  }

  /* ---------- Artikel: Inhaltsverzeichnis, Seitenleiste, Lesefortschritt, Video ---------- */
  function slug(t) {
    return t.toLowerCase().replace(/ä/g, 'ae').replace(/ö/g, 'oe').replace(/ü/g, 'ue').replace(/ß/g, 'ss')
      .replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 60) || 'abschnitt';
  }
  function initToc(root) {
    qsa('[data-th-toc]', root).forEach(function (toc) {
      if (!einmal(toc, 'Toc')) { return; }
      var liste = qs('[data-th-toc-list]', toc), toggle = qs('[data-th-toc-toggle]', toc);
      var quelle = toc.getAttribute('data-th-toc-auto') ? document.querySelector(toc.getAttribute('data-th-toc-auto')) : null;
      if (quelle && liste && !liste.children.length) {
        var vergeben = {};
        qsa('h2', quelle).forEach(function (h) {
          var text = (h.textContent || '').trim();
          if (!text || h.closest('.th-quiz, .th-v2-contact, .th-artikel-stationen')) { return; }
          if (!h.id) { var id = slug(text), n = 2; while (vergeben[id] || document.getElementById(id)) { id = slug(text) + '-' + n++; } h.id = id; }
          vergeben[h.id] = true;
          var li = document.createElement('li');
          li.innerHTML = '<a class="th-art-toc__link" href="#' + h.id + '">' + escapeHtml(text) + '</a>';
          liste.appendChild(li);
        });
      }
      if (!liste || liste.children.length < 2) { toc.hidden = true; return; }
      toc.hidden = false;
      var mq = window.matchMedia('(min-width: 1024px)');
      function stand() { var auf = mq.matches || toggle.getAttribute('aria-expanded') === 'true'; liste.hidden = !auf; }
      if (toggle) {
        toggle.setAttribute('aria-expanded', mq.matches ? 'true' : 'false');
        toggle.addEventListener('click', function () {
          if (mq.matches) { return; }
          toggle.setAttribute('aria-expanded', toggle.getAttribute('aria-expanded') === 'true' ? 'false' : 'true');
          stand();
        });
        if (mq.addEventListener) { mq.addEventListener('change', function () { toggle.setAttribute('aria-expanded', mq.matches ? 'true' : 'false'); stand(); }); }
        stand();
      }
      var links = qsa('a[href^="#"]', toc);
      var ziele = links.map(function (a) { return document.getElementById(a.getAttribute('href').slice(1)); }).filter(Boolean);
      if (!ziele.length || !('IntersectionObserver' in window)) { return; }
      var sichtbar = {};
      var spy = new window.IntersectionObserver(function (e) {
        e.forEach(function (x) { sichtbar[x.target.id] = x.isIntersecting; });
        var erstes = ziele.filter(function (z) { return sichtbar[z.id]; })[0];
        if (!erstes) { return; }
        links.forEach(function (a) {
          var ist = a.getAttribute('href') === '#' + erstes.id;
          a.classList.toggle('is-active', ist);
          if (ist) { a.setAttribute('aria-current', 'location'); } else { a.removeAttribute('aria-current'); }
        });
      }, { rootMargin: '-20% 0px -65% 0px', threshold: 0 });
      ziele.forEach(function (z) { spy.observe(z); });
    });
  }
  function initSeite(root) {
    qsa('[data-th-art-side]', root).forEach(function (side) {
      if (!einmal(side, 'Side')) { return; }
      var promo = qs('[data-th-art-promo]', side);
      if (!promo) { return; }
      var manuell = false, ctaSichtbar = false;
      var knopf = qs('[data-th-art-promo-open]', promo);
      function render() {
        var d = window.matchMedia('(min-width: 1024px)').matches;
        var bezug = side.parentElement || side;
        // Toms Vorgabe 15.10.: Produktkarte bleibt immer aufgeklappt und sichtbar (Fokus Kauf) – kein Einklappen, kein Ausblenden
        var kompakt = false;
        promo.classList.toggle('is-compact', kompakt);
        var weg = false;
        promo.classList.toggle('is-hidden', weg);
        promo.setAttribute('aria-hidden', weg ? 'true' : 'false');
        if ('inert' in promo) { promo.inert = weg; }
        if (knopf) { knopf.setAttribute('aria-expanded', kompakt ? 'false' : 'true'); }
      }
      var tick = false;
      window.addEventListener('scroll', function () { if (!tick) { tick = true; window.requestAnimationFrame(function () { tick = false; render(); }); } }, { passive: true });
      window.addEventListener('resize', render);
      if (knopf) { knopf.addEventListener('click', function () { manuell = true; render(); var c = qs('.th-art-promo__body .th-btn', promo); if (c) { c.focus({ preventScroll: true }); } }); }
      promo.addEventListener('mouseenter', function () { if (promo.classList.contains('is-compact')) { manuell = true; render(); } });
      promo.addEventListener('mouseleave', function () { manuell = false; render(); });
      var ziel = document.querySelector(side.getAttribute('data-th-art-side-cta') || '[data-th-art-cta]');
      if (ziel && 'IntersectionObserver' in window) {
        new window.IntersectionObserver(function (e) { ctaSichtbar = e.some(function (x) { return x.isIntersecting; }); render(); }, { threshold: 0.1 }).observe(ziel);
      }
      render();
    });
  }
  function initFortschritt(root) {
    qsa('[data-th-art-progress]', root).forEach(function (leiste) {
      if (!einmal(leiste, 'Prog')) { return; }
      var bar = qs('.th-art-progress__bar', leiste) || leiste;
      var ziel = document.querySelector(leiste.getAttribute('data-th-art-progress'));
      function update() {
        var top = 0, hoehe = document.documentElement.scrollHeight - window.innerHeight;
        if (ziel) { var r = ziel.getBoundingClientRect(); top = r.top + window.scrollY; hoehe = r.height - window.innerHeight; }
        var pct = hoehe > 0 ? Math.min(100, Math.max(0, ((window.scrollY - top) / hoehe) * 100)) : 0;
        bar.style.setProperty('--th-progress', pct.toFixed(1) + '%');
      }
      window.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }
  function initVideo(root) {
    qsa('[data-th-video]', root).forEach(function (fig) {
      if (!einmal(fig, 'Video')) { return; }
      var btn = qs('[data-th-video-laden]', fig);
      if (!btn) { return; }
      btn.addEventListener('click', function () {
        var buehne = qs('.th-video__buehne', fig);
        if (!buehne || fig.classList.contains('is-geladen')) { return; }
        var ifr = document.createElement('iframe');
        ifr.src = fig.getAttribute('data-th-video-src');
        ifr.title = fig.getAttribute('data-th-video-titel') || 'Video';
        ifr.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share');
        ifr.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
        ifr.setAttribute('allowfullscreen', '');
        buehne.innerHTML = '';
        buehne.appendChild(ifr);
        fig.classList.add('is-geladen');
        ifr.focus();
      });
    });
  }

  function init(root) {
    root = root || document;
    initPaketwahl(root);
    initVergleich(root);
    initForm(root);
    initSticky(root);
    initGalerie(root);
    initGrossansicht(root);
    initZeit(root);
    initApp(root);
    initHero(root);
    initMehr(root);
    initTabs(root);
    initFaq(root);
    initBeispiele(root);
    initQuiz(root);
    initToc(root);
    initSeite(root);
    initFortschritt(root);
    initVideo(root);
  }

  window.thV2 = { init: init, modal: modal, oeffneGrossansicht: oeffneGross };
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', function () { init(document); }); }
  else { init(document); }
  document.addEventListener('shopify:section:load', function (ev) { init(ev.target); });
})(window, document);
